"use client";

import dynamic from "next/dynamic";

const FreeTemplatesSignupForm = dynamic(
  () => import("./FreeTemplatesSignupForm"),
  {
    ssr: false,
    loading: () => (
      <div className="space-y-2">
        <div className="flex flex-col sm:flex-row gap-3">
          <div className="flex-1">
            <input
              id="free-templates-email-placeholder"
              name="email"
              type="email"
              autoComplete="email"
              placeholder="Enter your email"
              disabled
              aria-label="Enter your email"
              className="w-full h-12 px-4 py-3 bg-slate-900 border border-slate-700 rounded-lg text-white placeholder:text-slate-500 disabled:opacity-75"
            />
          </div>
          <button
            type="button"
            disabled
            className="flex items-center justify-center gap-2 px-6 py-3 bg-[#7f56d9] rounded-full text-white font-medium text-sm disabled:opacity-75 whitespace-nowrap"
          >
            Send Me the Templates
          </button>
        </div>
        <p className="font-inter font-normal text-slate-300 text-sm leading-5">
          No credit card required. Unsubscribe anytime.
        </p>
      </div>
    ),
  },
);

type FreeTemplatesSignupSlotProps = {
  buttonText: string;
  disclaimerText: string;
};

export default function FreeTemplatesSignupSlot(props: FreeTemplatesSignupSlotProps) {
  return <FreeTemplatesSignupForm {...props} />;
}
